import classnames from 'classnames';
import React from 'react';
import { Field } from 'react-final-form';

import { FormInput } from '../../../interfaces';
import { useFormInput } from '../../../libs/hooks';
import { InputLabelComponent } from '../../dsfr';

export const ReadOnlyComponent: React.FC<FormInput> = React.memo((props: FormInput) => {
  const { className, description, label, name } = props;

  const { id, texts } = useFormInput({ description, label, name });

  return (
    <Field component="input" name={id}>
      {({ input }) => (
        <div className={classnames('fr-input-group fr-input-group--readOnly', className)}>
          <InputLabelComponent id={id} texts={{ label: texts.label }} />
          <input className="fr-input" id={id} {...input} readOnly />
        </div>
      )}
    </Field>
  );
});

ReadOnlyComponent.displayName = 'ReadOnlyComponent';
